import { useDebounceFn } from 'ahooks';
import { useEffect, useState } from 'react';

const debounceWait = 300;

export const useDebouncedValue = <T,>(
  initialValue: T,
  onChange: (newValue: T) => void
) => {
  const [value, setValue] = useState<T>(initialValue);
  const { run: debouncedOnChange } = useDebounceFn(onChange, {
    wait: debounceWait,
  });

  const changeValue = (newValue: T) => {
    setValue(newValue);
    debouncedOnChange(newValue);
  };

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  return [value, changeValue] as const;
};
